module.exports = __webpack_public_path__ + "img/3.77a1f388.jpg";